import { movies } from "@/mocks/movies";
import type { MovieItem } from "@/mocks/movies";

export type SortKey = "time" | "views" | "rating";

export function getMovieById(id: string): MovieItem | undefined {
  return movies.find((m) => m.id === id);
}

export function getByType(type: "movie" | "tv"): MovieItem[] {
  return movies.filter((m) => m.type === type);
}

export function sortMovies(list: MovieItem[], sort: SortKey): MovieItem[] {
  const arr = [...list];
  if (sort === "rating") {
    return arr.sort((a, b) => b.rating - a.rating);
  }
  if (sort === "views") {
    return arr.sort((a, b) => b.views - a.views);
  }
  return arr.sort(
    (a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
  );
}

export interface FilterOptions {
  genres: string[];
  regions: string[];
  years: number[];
}

export function filterMovies(
  list: MovieItem[],
  options: Partial<FilterOptions>
): MovieItem[] {
  return list.filter((m) => {
    if (options.genres && options.genres.length > 0) {
      if (!options.genres.some((g) => m.genres.includes(g))) return false;
    }
    if (options.regions && options.regions.length > 0) {
      if (!options.regions.includes(m.region)) return false;
    }
    if (options.years && options.years.length > 0) {
      if (!options.years.includes(m.year)) return false;
    }
    return true;
  });
}

export function searchMovies(keyword: string, type?: "movie" | "tv"): MovieItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return movies.filter((m) => {
    if (type && m.type !== type) return false;
    const haystack = [
      m.title,
      m.director,
      ...m.actors,
      ...m.genres,
      m.region,
      ...m.tags,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelatedMovies(movie: MovieItem, limit = 5): MovieItem[] {
  return movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      const genreScore = m.genres.filter((g) =>
        movie.genres.includes(g)
      ).length;
      const regionScore = m.region === movie.region ? 1 : 0;
      const typeScore = m.type === movie.type ? 1 : 0;
      return { movie: m, score: genreScore * 3 + regionScore + typeScore };
    })
    .sort((a, b) => b.score - a.score || b.movie.rating - a.movie.rating)
    .slice(0, limit)
    .map((x) => x.movie);
}

export function getMoviesBySpecial(specialId: string): MovieItem[] {
  return movies.filter((m) => m.specials.includes(specialId));
}

export function getTypeLabel(type: string): string {
  return type === "movie" ? "电影" : "电视剧";
}